// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import { runtimeEnv } from "@/config/runtimeEnv";
import type { Database } from "./types";

const {
  url: SUPABASE_URL,
  publishableKey: SUPABASE_PUBLISHABLE_KEY,
} = runtimeEnv.getSupabaseClientConfig();

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
